import { ReactNode } from 'react';

type BoxProps = {
  title: string;
  children: ReactNode;
};

export const Box = ({ title, children }: BoxProps) => {
  return (
    <div className="icon-library--sidebar-box relative">
      {Boolean(title) && <div className="icon-library--sidebar-box-title opacity-50 mb-1 text-xs">{title}</div>}
      <div className="icon-library--sidebar-box-container bg-white shadow-md">{children}</div>
    </div>
  );
};
